<template>
  <div class="top">
    <div v-show="!ifShowDetail">
      <el-input
        class="top_input"
        v-model="query.title"
        placeholder="输入关键词"
        @keyup.enter="searchList"
        clearable
        @clear="clearInput"
      >
        <template #append>
          <el-icon style="font-size: 28px" @click="searchList"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <template v-if="list.length > 0">
        <div class="card_line">
          <div
            class="card_item"
            v-for="(ele, index) of list"
            :key="index"
            @click="chooseItem(ele)"
          >
            <div class="time_box">
              <div class="top">
                {{
                  ele.timeline.split(" ")
                    ? ele.timeline.split(" ")[0].split("-")[2]
                    : "-"
                }}
              </div>
              <div class="bottom">
                {{ ele.timeline.substring(0, 7) }}
              </div>
            </div>
            <div class="line_middle"></div>
            <div class="article_box">
              <div class="article_title">{{ ele.title }}</div>
              <div class="article">{{ ele.intro }}</div>
            </div>
          </div>
        </div>

        <div class="page_box">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </template>
      <div class="no_box" v-else>
        <img src="@/assets/text/nopicDe.png" alt="" />
        <div class="default_text">暂无数据</div>
      </div>
    </div>
    <div class="right_article2" v-if="ifShowDetail">
      <div class="small_title">
        <span
          @click="
            () => {
              ifShowDetail = false;
            }
          "
          >返回</span
        >
      </div>
      <div class="article_box">
        <div class="title">{{ nowChoose.title }}</div>
        <!-- <img :src="nowItem.thumbUrl" alt="" /> -->
        <img
          v-if="nowChoose.thumbUrl"
          :src="nowChoose.thumbUrl || defaultImg"
          alt=""
          onerror="this.onerror=null;this.src=defaultImg"
        />
        <div
          class="article g-rich-text-wrap"
          v-html="normalizeRichText(nowChoose.content)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Search } from "@element-plus/icons-vue";
import { ref, onMounted, defineProps, watch } from "vue";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import { useRoute } from "vue-router";
const route = useRoute();
let props = defineProps(["cid"]);
const total = ref(50);
const ifShowDetail = ref(false);
let query = ref({
  title: "",
  pageNo: 1,
  pageSize: 10,
  cid: "",
});
const list = ref([]);
const nowChoose = ref({});
const getList = async () => {
  let res = await api.getPageListByType(query.value);
  if (res.code === "0") {
    total.value = res.res.data.total;
    list.value = res.res.data.records;
  }
};
onMounted(() => {
  query.value.cid = props.cid;
  getList();
});
const handleCurrentChange = (val) => {
  query.value.pageNo = val;
  getList();
};
const searchList = () => {
  if (query.value.title) {
    getList();
  }
};
const clearInput = () => {
  getList();
};
const chooseItem = (item) => {
  ifShowDetail.value = true;
  nowChoose.value = item;
};
watch(
  () => route.query,
  (newValue) => {
    if (newValue && newValue.content && newValue.title) {
      api.getById({ id: newValue.content }).then((res) => {
        if (res.code === "0") {
          nowChoose.value.content = res.res.data.content;
          nowChoose.value.title = newValue.title;
          ifShowDetail.value = true;
        }
      });
    }
  },
  { immediate: true, deep: true }
);
</script>
<style lang="less" scoped>
:deep(.el-input-group__append) {
  background-color: #ffffff;
  cursor: pointer;
}
:deep(.el-input__wrapper) {
  box-shadow: 1px 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}
.no_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .default_text {
    margin-top: 21px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #317eb2;
    line-height: 22px;
  }
  img {
    width: 291px;
    height: 209px;
  }
}
.right_article2 {
  width: 100%;
  box-sizing: border-box;
  .small_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      font-style: normal;
      cursor: pointer;
    }
  }

  .article_box {
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #333333;
      line-height: 67px;
      font-style: normal;
      text-align: center;
      margin: 35px 0px 42px 0px;
    }
    img {
      width: 100%;
      height: 564px;
    }
    :deep(.article) {
      // font-family: PingFangSC, PingFang SC;
      // // font-weight: 600;
      // font-size: 16px;
      // color: #333333;
      // line-height: 30px;
      // text-align: left;
      // font-style: normal;
      // margin-top: 36px;
      // padding-bottom: 36px;
    }
    .detail_list {
      div {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        text-align: left;
        font-style: normal;
      }
    }
  }
}
.top_input {
  width: 666px;
  height: 70px;
  margin-bottom: 40px;
  background: #ffffff;
  // border: 1px solid #dcdcdc;
}
.page_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 96px;
}
.card_line {
  .card_item {
    cursor: pointer;
    width: 100%;
    height: 146px;
    background: #fafafa;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e7e7e7;
    .time_box {
      width: 146px;
      height: 100%;
      padding: 38px 0px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .top {
        font-family: LucidaGrande;
        font-size: 35px;
        color: #808080;
        line-height: 41px;
        font-style: normal;
      }
      .bottom {
        font-family: LucidaGrande;
        font-size: 16px;
        color: #9c9c9c;
        line-height: 19px;
        font-style: normal;
      }
    }
    .line_middle {
      width: 1px;
      height: 80px;
      background: #d1d1d1;
    }
    .article_box {
      flex: 1;
      padding: 0px 30px;
      .article_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        margin-bottom: 9px;
      }
      .article {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #969696;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .card_item:hover {
    box-shadow: 0px 0px 17px 0px rgba(176, 176, 176, 0.5);
    .time_box {
      background: #006ab1 !important;
      .top {
        color: #ffffff !important;
      }
      .bottom {
        color: #ffffff !important;
      }
    }
    .article_box {
      .article_title {
        color: #006ab1 !important;
      }
    }
  }
}
:deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #1c5db3 !important;
}
:deep(.el-pagination) {
  --el-pagination-hover-color: #1c5db3 !important;
}
:deep(.el-pagination.is-background .btn-next),
:deep(.el-pagination.is-background .btn-prev) {
  background-color: transparent !important;
}
</style>
